import { render, staticRenderFns } from "./NotificationPharmacySitesApprovalRequestForm.vue?vue&type=template&id=0633be38"
import script from "./NotificationPharmacySitesApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationPharmacySitesApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports